import {
  Model,
  ExerciseService as Service,
  Workout, Movement, Band
} from '@/internal';

export default class Exercise extends Model {

  static get key() {
    return 'exercise';
  }

  static get service() {
    return Service;
  }

  static get fields() {
    return {};
  }

  get bands() {
    const bands = this.hasMany(Band);

    return bands.length ? bands : this.hasMany(Band, null, null, 'band');
  }

  get movement() {
    return this.belongsTo(Movement);
  }

  get workout() {
    return this.belongsTo(Workout);
  }
}
